var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "clearfix",
      attrs: { method: "post" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit()
        }
      }
    },
    [
      _c("div", { staticClass: "input-unit mt-3" }, [
        _c(
          "label",
          { staticClass: "disabled", attrs: { for: "new-mail" + _vm._uid } },
          [_vm._v(_vm._s(_vm.$translate("Ceres::Template.myAccountNewEmail")))]
        ),
        _vm._v(" "),
        _c("input", {
          staticClass: "form-control",
          attrs: {
            type: "email",
            name: "email",
            id: "new-mail" + _vm._uid,
            disabled: ""
          },
          domProps: { value: _vm.newMail }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input-unit" }, [
        _c("label", { attrs: { for: "password" + _vm._uid } }, [
          _vm._v(_vm._s(_vm.$translate("Ceres::Template.loginPassword")))
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.password,
              expression: "password"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "password",
            name: "password",
            autocomplete: "current-password",
            id: "password" + _vm._uid
          },
          domProps: { value: _vm.password },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.password = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "btn btn-primary btn-appearance float-right btn-medium btn-xs-max-width",
          attrs: { type: "submit", disabled: _vm.isDisabled }
        },
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$translate("Ceres::Template.myAccountChangeEmail"))
            )
          ]),
          _vm._v(" "),
          _c("icon", { attrs: { icon: "envelope", loading: _vm.isDisabled } })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }